angular.module('impactx.confirmation').controller('ConfirmationCtrl', [
    '$scope',
    '$mdDialog',
    'warning',
    'saveLabel',
    'abortLabel',
    'question',
    'themeFactory',
    ConfirmationCtrl]);

function ConfirmationCtrl($scope, $mdDialog, warning, saveLabel, abortLabel, question, themeFactory)
{
    $scope.warning = warning;
    $scope.saveLabel = saveLabel;
    $scope.abortLabel = abortLabel;
    $scope.question = question;
    $scope.theme = themeFactory.getTheme();

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function ()
    {
        $mdDialog.hide();
    };
}